import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserManageDialog from "@/v2-backoffice-client/tenant/user/manage/TenantUserManageDialog"

export type TenantUserManageButtonProps = ButtonProps & {
  tenantId: number
  tenantName?: string
  existingUserTenants?: UserTenantFragment[]
}

function TenantUserManageButton(props: TenantUserManageButtonProps) {
  const {
    tenantId,
    tenantName,
    existingUserTenants = [],
    onClick,
    children,
    ...buttonProps
  } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="user-gear"
        iconSize={12}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Manage users"}
      </Button>

      <TenantUserManageDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        tenantId={tenantId}
        tenantName={tenantName}
        existingUserTenants={existingUserTenants}
      />
    </>
  )
}

export default TenantUserManageButton
